import { Skeleton } from '@displate/styleguide';

import { DEFAULT_NUM_OF_ARTWORKS_TO_DISPLAY } from '@/common/components/MasonryFeed/MasonryFeedGrid';

import styles from './masonryFeedSkeleton.module.scss';

export const MasonryFeedSkeleton = () => {
  return (
    <div className={styles.masonryFeedSkeleton}>
      <div className={styles.masonryFeedHeaderSkeleton}>
        <Skeleton className={styles.skeleton} />
      </div>
      <div className={styles.masonryFeedGridSkeleton}>
        {[...Array(DEFAULT_NUM_OF_ARTWORKS_TO_DISPLAY).keys()].map((index) => {
          return <Skeleton className={styles.skeleton} key={index} />;
        })}
      </div>
      <div className={styles.masonryFeedButtonSkeleton}>
        <Skeleton className={styles.skeleton} />
      </div>
    </div>
  );
};
